'use client';

import { c as _c } from "react/compiler-runtime";
import { ClerkProvider as ClerkProviderImpl, GoogleOneTap as GoogleOneTapImpl, UserButton as UserButtonImpl, useAuth } from '@clerk/nextjs';
import { dark } from '@clerk/themes';
import { useEffect, useState } from 'react';
import { BRAND_CONFIG, type BrandId } from '@/features/brand/config';
import { isSatelliteHost } from './domain';
const BRAND_ACCENT_COLOR = '#F52F00';
const PRIMARY_SIGN_IN_URL_PROD = 'https://wwjdfilm.com/sign-in';
const PRIMARY_SIGN_UP_URL_PROD = 'https://wwjdfilm.com/sign-up';
const PRIMARY_SIGN_IN_URL_DEV = 'http://localhost:3000/sign-in';
const PRIMARY_SIGN_UP_URL_DEV = 'http://localhost:3000/sign-up';
export function ClerkProvider(t0) {
  const $ = _c(18);
  const {
    brandId,
    host,
    isSatellite,
    children
  } = t0;
  const config = BRAND_CONFIG[brandId];
  const t1 = `Sign in to ${config.lettermark}`;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      start: {
        title: t1
      }
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `Create your ${config.lettermark} account`;
  let t4;
  if ($[2] !== t3) {
    t4 = {
      start: {
        title: t3
      }
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t4) {
    t5 = {
      signIn: t2,
      signUp: t4
    };
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const localization = t5;
  const primarySignInUrl = process.env.NODE_ENV === "development" ? PRIMARY_SIGN_IN_URL_DEV : PRIMARY_SIGN_IN_URL_PROD;
  const primarySignUpUrl = process.env.NODE_ENV === "development" ? PRIMARY_SIGN_UP_URL_DEV : PRIMARY_SIGN_UP_URL_PROD;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = ["https://christspiracy.com", "https://www.christspiracy.com", ...(process.env.NODE_ENV === "development" ? ["http://localhost:3001"] : [])];
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const allowedRedirectOrigins = t6;
  let t7;
  if ($[8] !== host || $[9] !== isSatellite) {
    t7 = isSatellite ? {
      isSatellite: true,
      domain: host,
      signInUrl: primarySignInUrl,
      signUpUrl: primarySignUpUrl
    } as const : {
      signInUrl: "/sign-in",
      signUpUrl: "/sign-up",
      allowedRedirectOrigins
    } as const;
    $[8] = host;
    $[9] = isSatellite;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const clerkProps = t7;
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      theme: "dark",
      size: "flexible",
      language: "auto"
    };
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t10;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      captcha: t8,
      theme: dark,
      variables: {
        colorPrimary: BRAND_ACCENT_COLOR,
        colorPrimaryForeground: "#ffffff",
        colorBackground: "#1d1d1d",
        colorInput: "#262626",
        colorInputForeground: "#f1f1f1",
        colorForeground: "#f1f1f1",
        colorMutedForeground: "#969b8d",
        fontFamily: "var(--font-formula-normal), sans-serif",
        borderRadius: "0.1rem",
        fontSize: "14px"
      },
      options: {
        socialButtonsPlacement: "bottom",
        socialButtonsVariant: "iconButton",
        logoPlacement: "none",
        unsafe_disableDevelopmentModeWarnings: true
      },
      elements: {
        card: "rounded-[0.1rem] bg-christ-black-900 border border-white/10 shadow-2xl",
        headerTitle: "font-formula-condensed font-bold text-2xl tracking-wide text-white",
        headerSubtitle: "font-formula-normal text-xs uppercase tracking-widest text-christ-gray-400",
        formButtonPrimary: "rounded-[0.1rem] uppercase font-formula-normal tracking-widest text-xs hover:opacity-90 transition-opacity text-white",
        socialButtonsIconButton: "rounded-[0.1rem] border border-white/20 hover:bg-white/10 hover:border-white/40 transition-all",
        formFieldInput: "rounded-[0.1rem] bg-[#262626] border-transparent focus:border-[var(--clerk-color-primary)] transition-colors",
        formFieldLabel: "uppercase text-[10px] tracking-widest text-christ-gray-400 mb-1",
        footer: "hidden",
        footerActionLink: "text-[var(--clerk-color-primary)] hover:text-white transition-colors",
        dividerLine: "bg-white/10",
        dividerText: "text-christ-gray-400 uppercase text-[10px] tracking-widest"
      }
    };
    t10 = <div id="clerk-captcha" className="fixed right-4 bottom-4 z-2147483647 max-w-[min(90vw,360px)] empty:hidden" data-cl-theme="dark" data-cl-size="flexible" data-cl-language="auto" />;
    $[12] = t10;
    $[13] = t9;
  } else {
    t10 = $[12];
    t9 = $[13];
  }
  let t11;
  if ($[14] !== children || $[15] !== clerkProps || $[16] !== localization) {
    t11 = <ClerkProviderImpl afterSignOutUrl="/" {...clerkProps} localization={localization} appearance={t9}>{t10}{children}</ClerkProviderImpl>;
    $[14] = children;
    $[15] = clerkProps;
    $[16] = localization;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
}
export function GoogleOneTap() {
  const $ = _c(3);
  const {
    isSignedIn
  } = useAuth();
  const [mounted, setMounted] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setMounted(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (!mounted) {
    return null;
  }
  if (isSignedIn) {
    return null;
  }
  const host = window.location.host;
  const satellite = isSatelliteHost(host, process.env.NODE_ENV === "development" ? "development" : "production");
  if (satellite) {
    return null;
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <GoogleOneTapImpl fedCmSupport={false} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export function UserButton() {
  const $ = _c(3);
  const [mounted, setMounted] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setMounted(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (!mounted) {
    return null;
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <UserButtonImpl appearance={{
      theme: dark,
      elements: {
        userButtonAvatarBox: "rounded-[0.1rem] border border-white/20",
        userButtonPopoverCard: "rounded-[0.1rem] bg-christ-black-900 border border-white/10 shadow-2xl",
        userButtonPopoverActionButton: "hover:bg-white/5 text-white/90",
        userButtonPopoverActionButtonIcon: "text-[var(--clerk-color-primary)]",
        userButtonPopoverFooter: "hidden"
      }
    }} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}